document.addEventListener('DOMContentLoaded', function () {
  const players = document.querySelectorAll('.lottie-features');

  // A queue to hold players waiting to animate
  const animationQueue = [];
  let isProcessingQueue = false;

  // Configuration
  const STAGGER_DELAY = 500; // Time in ms to wait before starting the next animation

  // Function to process the queue one by one
  const processQueue = () => {
    // Stop if the queue is empty
    if (animationQueue.length === 0) {
      isProcessingQueue = false;
      return;
    }

    isProcessingQueue = true;
    const player = animationQueue.shift(); // Get the next player in line

    // Play the animation
    player.setDirection(1);
    player.setSpeed(1);
    player.play();

    // Wait before triggering the next one
    setTimeout(() => {
      processQueue();
    }, STAGGER_DELAY);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const player = entry.target;

        if (entry.isIntersecting) {
          // Only add to queue if it's not already playing or queued
          // We use a custom property 'hasPlayed' to prevent re-triggering while visible
          if (!player.hasPlayed) {
            player.hasPlayed = true; // Mark as handled for this visibility session
            animationQueue.push(player);

            // If the processor isn't running, start it
            if (!isProcessingQueue) {
              processQueue();
            }
          }
        } else {
          // Reset when out of view so it can play again next time (optional)
          player.pause();
          player.hasPlayed = false;
        }
      });
    },
    { threshold: 0.5 } // Trigger when 50% visible
  );

  // Apply the observer to all players
  players.forEach((player) => {
    observer.observe(player);
  });
});